import React, { PureComponent } from 'react';
import { NavLink } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from './logonew.png';

class Navbar extends PureComponent {
  render() {
    return (
      <nav className="navbar navbar-expand-lg navbar-light" style={{ backgroundColor: 'black' }}>
        <div className="container-fluid">
          {/* Logo on the extreme left */}
          <NavLink to="/" className="navbar-brand" style={{ marginLeft: '0' }}>
            <img 
              src={logo} 
              alt="Logo" 
              style={{ height: '50px', width: 'auto', marginRight: '20px' }} 
            />
          </NavLink>

          {/* Navbar Toggler - make the icon white */}
          <button 
            className="navbar-toggler" 
            type="button" 
            data-bs-toggle="collapse" 
            data-bs-target="#navbarNav" 
            aria-controls="navbarNav" 
            aria-expanded="false" 
            aria-label="Toggle navigation"
            style={{ borderColor: 'white' }}  // White border for the toggler button
          >
            <span 
              className="navbar-toggler-icon" 
              style={{
                backgroundImage: `url("data:image/svg+xml;charset=UTF8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255, 255, 255, 1)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E")`
              }}
            ></span>
          </button>

          {/* Centered navigation tabs */}
          <div className="collapse navbar-collapse justify-content-center" id="navbarNav">
            <ul className="navbar-nav mx-auto">
              <li className="nav-item">
                <NavLink 
                  to="/buy" 
                  className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
                  style={({ isActive }) => ({ color: isActive ? '#FFD700' : 'white' })}
                >
                  Buy
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink 
                  to="/stock" 
                  className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
                  style={({ isActive }) => ({ color: isActive ? '#FFD700' : 'white' })}
                >
                  Stock
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink 
                  to="/clients" 
                  className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
                  style={({ isActive }) => ({ color: isActive ? '#FFD700' : 'white' })}
                >
                  Clients
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink 
                  to="/transactions" 
                  className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
                  style={({ isActive }) => ({ color: isActive ? '#FFD700' : 'white' })}
                >
                  Transactions
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink 
                  to="/convert" 
                  className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
                  style={({ isActive }) => ({ color: isActive ? '#FFD700' : 'white' })}
                >
                  Convert
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink 
                  to="/speed" 
                  className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
                  style={({ isActive }) => ({ color: isActive ? '#FFD700' : 'white' })}
                >
                  Speed
                </NavLink>
              </li>
              {/* Add Dropdown */}
              <li className="nav-item dropdown">
                <NavLink 
                  className="nav-link dropdown-toggle" 
                  to="#" 
                  id="navbarDropdown" 
                  role="button" 
                  data-bs-toggle="dropdown" 
                  aria-expanded="false"
                  style={{ color: 'white' }}
                >
                  Add
                </NavLink>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li>
                    <NavLink 
                      to="/add-to-pure" 
                      className="dropdown-item"
                      style={({ isActive }) => ({ color: isActive ? '#FFD700' : 'black' })}
                    >
                      Add to Pure
                    </NavLink>
                  </li>
                  <li>
                    <NavLink 
                      to="/add-to-langdi" 
                      className="dropdown-item"
                      style={({ isActive }) => ({ color: isActive ? '#FFD700' : 'black' })}
                    >
                      Add to Langdi
                    </NavLink>
                  </li>
                  <li>
                    <NavLink 
                      to="/add-cash" 
                      className="dropdown-item"
                      style={({ isActive }) => ({ color: isActive ? '#FFD700' : 'black' })}
                    >
                      Add to Cash
                    </NavLink>
                  </li>
                </ul>
              </li>
              {/* Sell Dropdown */}
              <li className="nav-item dropdown">
                <NavLink 
                  className="nav-link dropdown-toggle" 
                  to="#" 
                  id="navbarDropdownSell" 
                  role="button" 
                  data-bs-toggle="dropdown" 
                  aria-expanded="false"
                  style={{ color: 'white' }}
                >
                  Sell
                </NavLink>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdownSell">
                  <li>
                    <NavLink 
                      to="/sell-pure-weight" 
                      className="dropdown-item"
                      style={({ isActive }) => ({ color: isActive ? '#FFD700' : 'black' })}
                    >
                      Sell Pure Weight
                    </NavLink>
                  </li>
                  <li>
                    <NavLink 
                      to="/sell-langdi-weight" 
                      className="dropdown-item"
                      style={({ isActive }) => ({ color: isActive ? '#FFD700' : 'black' })}
                    >
                      Sell Langdi Weight
                    </NavLink>
                  </li>
                  <li>
                    <NavLink 
                      to="/sell-cash-amount" 
                      className="dropdown-item"
                      style={({ isActive }) => ({ color: isActive ? '#FFD700' : 'black' })}
                    >
                      Sell Cash Amount
                    </NavLink>
                  </li>
                  // Inside the ul of navbar-nav


                </ul>
              </li>
            
<li className="nav-item">
  <NavLink 
    to="/advance" 
    className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
    style={({ isActive }) => ({ color: isActive ? '#FFD700' : 'white' })}
  >
    Advance
  </NavLink>
</li>

            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

export default Navbar;
